import { gql } from "@apollo/client";


export const GET_WORK_SESSIONS = gql`
    query WorkSessionsCursor(
        $where: QueryWorkSessionsCursorWhereWhereConditions
        $orderBy: [QueryWorkSessionsCursorOrderByOrderByClause!]
        $first: Int
        $after: String
    ) {
        workSessionsCursor(
            where: $where
            orderBy: $orderBy
            first: $first
            after: $after
        ) {
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
                total
                currentPage
                lastPage
            }
            edges {
                node {
                    id
                    ee_id
                    check_in_at
                    check_out_at
                    created_at
                    updated_at
                }
            }
        }
    }
`;
